var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "19px",
    viewBox: "0 13.813 17 19",
    enableBackground: "new 0 13.813 17 19",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.3203,
    y1: -322.9829,
    x2: 272.6719,
    y2: -322.9829,
    gradientTransform: "matrix(1 0 0 -1 -256 -299.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0699,
    style: {
      stopColor: "#D0DCE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0DCE8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M9.617,32.43l6.039-3.5c0.688-0.398,1.016-0.766,1.016-1.32c0-0.563-0.328-0.922-1.016-1.328 l-0.906-0.523l0.906-0.523c0.688-0.398,1.016-0.766,1.016-1.319c0-0.563-0.328-0.922-1.016-1.32l-1.078-0.625l1.078-0.625 c0.688-0.406,1.016-0.766,1.016-1.32c0-0.563-0.328-0.922-1.016-1.328l-6.039-3.5c-0.438-0.25-0.773-0.383-1.125-0.383 c-0.344,0-0.68,0.133-1.117,0.383l-6.039,3.5C0.648,19.102,0.32,19.46,0.32,20.023c0,0.555,0.328,0.914,1.016,1.32l1.078,0.625 l-1.078,0.625c-0.688,0.399-1.016,0.758-1.016,1.321c0,0.555,0.328,0.921,1.016,1.319l0.906,0.523l-0.906,0.523 c-0.688,0.406-1.016,0.766-1.016,1.328c0,0.555,0.328,0.922,1.016,1.32l6.039,3.5c0.438,0.25,0.773,0.383,1.117,0.383 C8.844,32.813,9.18,32.68,9.617,32.43z M8.492,23.344c-0.094,0-0.18-0.031-0.289-0.094l-5.562-3.156 c-0.039-0.016-0.055-0.039-0.055-0.07c0-0.039,0.016-0.063,0.055-0.078l5.563-3.156c0.109-0.063,0.195-0.094,0.289-0.094 c0.094,0,0.18,0.031,0.297,0.094l5.563,3.156c0.03,0.016,0.055,0.039,0.055,0.078c0,0.031-0.023,0.055-0.055,0.07L8.789,23.25 C8.672,23.313,8.586,23.344,8.492,23.344z M8.492,25.227c0.352,0,0.688-0.133,1.125-0.383l3.219-1.867l1.516,0.858 c0.031,0.023,0.056,0.039,0.056,0.078c0,0.031-0.023,0.056-0.056,0.07l-5.563,3.165c-0.117,0.063-0.203,0.094-0.297,0.094 c-0.094,0-0.18-0.031-0.289-0.094l-5.562-3.164c-0.039-0.016-0.055-0.039-0.055-0.069c0-0.039,0.016-0.056,0.055-0.078l1.516-0.859 l3.219,1.867C7.813,25.094,8.148,25.227,8.492,25.227z M8.203,30.836L2.641,27.68c-0.039-0.016-0.055-0.039-0.055-0.07 c0-0.039,0.016-0.055,0.055-0.078l1.344-0.758l3.391,1.961c0.437,0.25,0.772,0.383,1.116,0.383c0.352,0,0.688-0.133,1.125-0.383 l3.391-1.961l1.344,0.758c0.031,0.023,0.056,0.039,0.056,0.078c0,0.031-0.023,0.055-0.056,0.07l-5.563,3.156 c-0.117,0.063-0.203,0.094-0.297,0.094C8.398,30.93,8.313,30.898,8.203,30.836z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStake);
export default __webpack_public_path__ + "static/media/stake.4b4614a4fd6e1803d061751236632bc9.svg";
export { ForwardRef as ReactComponent };